import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationService } from "../../../services/navigation/navigation.service";
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth/auth.service';
import { environment } from 'environments/environment';
import { releaseInfo } from 'app/release-info.config';

import { interval, timer } from 'rxjs';
import { DataStoreService } from 'app/services/datastore.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { SessionTimedOutComponent } from '../session-timed-out/session-timed-out.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'navigation',
  templateUrl: './navigation.template.html',
  standalone: false
})
export class NavigationComponent {
  @ViewChild('sessionTimeout') sessionTimeout: ElementRef;

  hasIconTypeMenuItem;
  iconTypeMenuTitle: string;
  menuItems: any[];
  session: any;
  env: any;
  relInfo:any;
  apiServerStatus: any = { "DataSource": "loading", "InitialCatalog": "loading", "DBStatus": "UNKNOWN" };
  dataServerStatus: any = { "Server": "loading", "Database": "loading", "DBStatus": "UNKNOWN" };
  idleInterval: any;
  sessionTimeDisplay: number;
  sessionData: any;

  intervalSubscription
  expireTime;
  user;
  logOutNextDayInterval: any;
  sessionCheckFailures = 0;
  readonly MAX_SESSION_FAILURES = 5;
  readonly NORMAL_POLL_INTERVAL = 300000;  // 5 minutes
  readonly FAILURE_POLL_INTERVAL = 60000;  // 1 minute
  isInFailureRecoveryMode = false;

  constructor(
    private navService: NavigationService,
    private router: Router,
    private auth: AuthService,
    private ds: DataStoreService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    
  ) { }

  async ngOnInit() {
    this.env = environment;
    this.relInfo = releaseInfo;
    this.session = this.auth.session;
    this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
    // Loads menu items from NavigationService
    this.navService.menuItems$.subscribe(async menuItem => {
      this.menuItems = menuItem;
      this.hasIconTypeMenuItem = !!this.menuItems.filter(item => item.type === 'icon').length;
    });

    this.auth.getServerStatus(this.env.siteReviewURL)
      .subscribe((retval: any) => {
        this.dataServerStatus = retval;
        this.auth.database = retval.Database;
        this.checkUrls();
        //this.subscribeToServerTimeOut()
      });
    
    
    // this is not working with PDF endpoint

    // this.auth.getPDFServerStatus(this.env.serverURL)
    //   .subscribe(retval => {
    //     this.apiServerStatus = retval;
    //     this.toastr.success("PDF Server Status", "PDF Server Status", {
    //       timeOut: 2000
    //     });
    //   });
    
    this.checkSessionIdle();
    this.startLogOutNextDayInterval();
  }

 checkUrls() {
  const currentDomain = window.location.hostname;

  const isLocalDev = currentDomain.includes('localhost');
  const isDev = currentDomain.includes('dev.pinnaclepowerservices.com') || isLocalDev;
  const isAlpha = currentDomain.includes('alpha.pinnaclepowerservices.com');
  const isBeta = currentDomain.includes('beta.pinnaclepowerservices.com');
  const isProd = currentDomain.includes('dash.pinnaclepowerservices.com');

  let expectedDatabase: string;

  if (isProd || isBeta) {
    expectedDatabase = 'SiteReviewProduction';
  } else if (isAlpha) {
    expectedDatabase = 'SiteReviewAlpha';
  } else if (isDev) {
    expectedDatabase = 'SiteReview';
  } else {
    expectedDatabase = 'UNKNOWN';
  }

  let expectedApi: string[];

  if (isProd) {
    expectedApi = [
      'sitereview-api-production-344908434643.us-west1.run.app',
      'pinnacle.apidas.com'
    ];
  } else if (isBeta) {
    expectedApi = [
      'sitereview-api-beta-344908434643.us-west1.run.app',
      'beta-api.apidas.com'
    ];
  } else if (isAlpha) {
    expectedApi = [
      'sitereview-api-alpha-344908434643.us-west1.run.app'
    ];
  } else if (isDev) {
    expectedApi = [
      'server19.apidas.com',
      'localhost'
    ];
  } else {
    expectedApi = ['UNKNOWN'];
  }

  const normalizedEnvServer = this.env.siteReviewURL
    .replace(/^https?:\/\//i, '')
    .replace(/\/$/, '')
    .split(':')[0];

  const serverMismatch = !expectedApi.includes(normalizedEnvServer);
  const dbMismatch = this.dataServerStatus.Database !== expectedDatabase;
  const statusMismatch = this.dataServerStatus.DBStatus !== 'SUCCESS';

  const showMismatchBar = serverMismatch || dbMismatch || statusMismatch;

  if (showMismatchBar) {
    const details = [];

    if (serverMismatch) details.push('Server Mismatch');
    if (dbMismatch) details.push('Database Mismatch');
    if (statusMismatch) details.push('Status Mismatch');

    this.toastr.error(details.join(' | '), 'System is not working properly', {
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: false,
      closeButton: true,
      positionClass: 'toast-top-full-width',
      progressBar: false,
      disableTimeOut: true,
      toastClass: 'ngx-toastr system-warning-toast'
    });
  }
}

  filterMenu(groups: string[], groupName: string, menuName: string) {
    let devs = groups.filter(g => g === groupName);
    if (devs.length == 0) {
      this.menuItems = this.menuItems.filter(obj => obj.name != menuName)
    }
  }

  gotToDash() {
    this.router.navigate(['dashboard']);
  }


  checkSessionIdle() {
    let sID = localStorage.getItem('sr_session_id');
    this.serverSideExpires(sID);
    this.startSessionPolling(sID, this.NORMAL_POLL_INTERVAL);
  }

  startSessionPolling(sID: string, intervalMs: number) {
    if (this.idleInterval) {
      this.idleInterval.unsubscribe();
    }
    this.idleInterval = interval(intervalMs).subscribe(() => {
      this.serverSideExpires(sID);
    });
  }

  getSession(sID) {
    this.auth.getSession(sID).subscribe((res: any) => {
      //console.log("SESSION DATA => ", res);
      let newDateInMilliseconds = new Date().getTime();
      let sessionDate = new Date(res.SessionDate).getTime();


      let sessionTimeoutMinutesToMills = res.SessionTimeoutMinutes * 60000;
      let sessionTime = sessionDate + sessionTimeoutMinutesToMills;
      this.sessionTimeDisplay = Math.round((sessionTime - newDateInMilliseconds) / 60000);
      //console.log("sessionTimeDisplay => ", this.sessionTimeDisplay)
      if (newDateInMilliseconds > sessionTime) {
        //alert('logOUT user!')
        this.idleInterval.unsubscribe();
        this.auth.logout();
      } else {
        return;
      }
    });
  }

  serverSideExpires(sID) {
    this.auth.getSession(sID).subscribe((res: any) => {
      // Reset failure tracking and switch back to normal polling if recovering
      if (this.isInFailureRecoveryMode) {
        //console.log('Session check recovered, switching back to normal polling');
        this.isInFailureRecoveryMode = false;
        this.startSessionPolling(sID, this.NORMAL_POLL_INTERVAL);
      }
      this.sessionCheckFailures = 0;

      this.sessionData = res;
      this.sessionData = { ...this.sessionData, sID: sID };

      let expiredDate = new Date(res.SessionDate).toLocaleDateString();
      let expiresInMinutes = res.ExpiresInMinutes;
      this.sessionTimeDisplay = expiresInMinutes;
      if (expiredDate === "1/1/1900" || expiresInMinutes <= 1) {
        this.dialog.closeAll();
        this.sessionData = { ...this.sessionData, expiredUser: true };
        this.openSessionTimedOut();
        this.idleInterval.unsubscribe();
      }

      if (expiresInMinutes <= 10 && expiresInMinutes > 1) {
        this.dialog.closeAll();
        this.sessionData = { ...this.sessionData, refreshUser: true };
        this.openSessionTimedOut();
      }
    }, err => {
      this.sessionCheckFailures++;
      //console.log(`Session check failed (${this.sessionCheckFailures}/${this.MAX_SESSION_FAILURES}):`, err);

      // Switch to faster polling on first failure
      if (!this.isInFailureRecoveryMode) {
        //console.log('Session check failed, switching to recovery polling (1 min)');
        this.isInFailureRecoveryMode = true;
        this.startSessionPolling(sID, this.FAILURE_POLL_INTERVAL);
      }

      if (this.sessionCheckFailures >= this.MAX_SESSION_FAILURES) {
        //console.log('Max session failures reached, logging out');
        this.idleInterval.unsubscribe();
        this.auth.logout();
      }
    })
  }

  openSessionTimedOut() {
    //console.log("sessionTimeOut pop upsessionData => ", this.sessionData);
    const config: MatDialogConfig = new MatDialogConfig();
    config.data = this.sessionData;
    config.width = "500px";
    config.height = "350px";
    config.disableClose = true;
    const dialogRef = this.dialog.open(SessionTimedOutComponent, config);
    dialogRef.afterClosed().subscribe(res => {
      //console.log('Dialog res => ', res);
      if (res === "refreshUserSession") {
        this.idleInterval.unsubscribe();
        this.checkSessionIdle();
      }
    })
  }

  startLogOutNextDayInterval() {
    this.logOutNextDay();
    this.logOutNextDayInterval = interval(15000).subscribe(() => {
      this.logOutNextDay();
    });
  }

  logOutNextDay() {
    const lastLoginString = localStorage.getItem('lastLogin');
    if (lastLoginString) {
      const lastLogin = new Date(lastLoginString);
      const today = new Date();
      if (today.getDate() !== lastLogin.getDate() || today.getMonth() !== lastLogin.getMonth() || today.getFullYear() !== lastLogin.getFullYear()) {
        // If last login is not today, perform logout
        this.auth.logout();
        this.logOutNextDayInterval.unsubscribe();
      } else {
        //console.log('we are in the same day, not login out')
      }
    }
  }

  navigateTo(event: Event, parentState: string, childState: string, queryParams?: any) {
    event.stopPropagation();  
    event.preventDefault();   
  
    let path = '/';
    if (parentState) {
      path += parentState + '/';
    }
    path += childState;
  
    this.router.navigate([path], { queryParams: queryParams || {} });
    
  }
}